import axios from "axios";
import { API_ROOT } from "./apiConfig";

var config = {
  headers: { "Access-Control-Allow-Origin": "*" },
};

const editorAxios = axios.create(
  {
    baseURL: API_ROOT,
  },
  config
);

export default editorAxios;
